<template>
    <!-- 添加数据2 -->

    <a-modal title="新增菜单" v-model:open="open" @ok="handleOk" class="modals">
        <div class="push-input">
            <a><span class="startColor">*</span>菜单名称：</a>
            <a-input v-model:value="pushData.menuName" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>菜单代码：</a>
            <a-input v-model:value="pushData.menuCode" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>菜单链接：</a>
            <a-input v-model:value="pushData.url" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>菜单图标：</a>
            <a-input v-model:value="pushData.icon" maxlength="20" class="push-data" />
        </div>
        <div class="push-inpu">
            <a><span class="startColor">*</span>父级菜单：</a>
            <a-select v-model:value="pushData.parentMenuId"  class="push-data">
                <a-select-option v-for="p in parent" :key="p.id" :value="p.id">{{p.menuName}}</a-select-option>
            </a-select>
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>菜单排序：</a>
            <a-input v-model:value="pushData.orderIndex" maxlength="2" type="number" class="push-data" />
        </div>
        <template #footer>
            <a-button key="back" @click="toAddCancel">返回</a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">提交</a-button>
        </template>
    </a-modal>
</template>
<script>
import { saveMenus,listParentMenus } from '@/api/service';
import { message } from 'ant-design-vue';
import { ref } from 'vue';
export default {
    name: 'addComponent',
    setup() {
        const loading = ref(false);//添加提交时的加载
        const pushData = ref({});//提交数据
        const open = ref(false);//是否打开
        const parent = ref([]);//父级菜单
        //关闭窗口
        const toAddCancel = () => {
            open.value = false;
        }
        //查询父级列表
        const parentList = async ()=>{
            const response = await listParentMenus();
            if (response.code === 200) {
                parent.value = response.data;
            }
        }
        //提交数据
        const handleOk = async () => {
            console.log(pushData.value);
            const response = await saveMenus(pushData.value);
            if (response.code === 200) {
                message.success('添加成功');
                open.value = false;
            } else {
                message.error('添加失败' + response.msg);
                return false;
            }
        }
        parentList();
        return {
            loading,
            open,
            pushData,
            listParentMenus,
            parent,
            parentList,
            toAddCancel,
            handleOk,
            ref
        };
    }
}
</script>
<style>
.push-input {
    margin-top: 20px;
    display: block;
}

.modals {
    width: 400px;
}

.push-data {
    width: 80%;
}
</style>